import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapActions } from "vuex";
import Err from "../../../../routes/error";
import NotificationsPage from "../../../../../../shared/components/settings/notifications/notifications-page";
import { LOAD_NOTIFICATION_PREFERENCES, UPDATE_NOTIFICATION_PREFERENCES } from "@Client/@Modules/main/store/account/account-actions";
import { showToast } from "../../../../../../shared/utils/constants";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "NotificationsContainer",
  components: {
    NotificationsPage
  },
  props: {
    saving: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      loading: false
    };
  },
  computed: _objectSpread({}, mapState("AccountStore", ["notificationPreferences"])),
  watch: {
    saving(value) {
      if (!value) return;
      this.$refs.notifications.handleSubmit();
    }
  },
  async mounted() {
    this.loading = true;
    await this.LOAD_NOTIFICATION_PREFERENCES();
    this.loading = false;
  },
  methods: _objectSpread(_objectSpread({}, mapActions("AccountStore", [LOAD_NOTIFICATION_PREFERENCES, UPDATE_NOTIFICATION_PREFERENCES])), {}, {
    async handleSubmit(preferences) {
      this.loading = true;
      try {
        await this.UPDATE_NOTIFICATION_PREFERENCES({
          preferences
        });
        this.$emit("finish-saving", true);
        showToast("success", "notificationPreferencesUpdated");
      } catch (e) {
        this.$emit("finish-saving", false);
        Err.handle(e);
      } finally {
        this.loading = false;
      }
    },
    handleAllowSave(allowSave) {
      this.$emit("allow-save", allowSave);
    }
  })
});